// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';
import AwBreak from 'viewmodel/AwBreakViewModel';
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
import DesCatalogCarousel from 'viewmodel/DesCatalogCarouselViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
    import { ExistWhen } from 'js/hocCollection';
const AwPanelExistWhen = ExistWhen(AwPanel);
const AwFlexColumnExistWhen = ExistWhen(AwFlexColumn);
const AwFlexRowExistWhen = ExistWhen(AwFlexRow);
const AwLabelExistWhen = ExistWhen(AwLabel);
AwPanelExistWhen.displayName = 'AwPanelExistWhen';
AwFlexColumnExistWhen.displayName = 'AwFlexColumnExistWhen';
AwFlexRowExistWhen.displayName = 'AwFlexRowExistWhen';
AwLabelExistWhen.displayName = 'AwLabelExistWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/DesCatalogPartConfigService', () => import('js/DesCatalogPartConfigService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "lifecycleHooks": {
        "onUpdate": {
            "action": "setProductSelection",
            "observers": [
                "viewModel.dataProviders.partSummaryTableRowProvider.viewModelCollection.loadedVMObjects"
            ]
        },
        "onMount": {
            "action": "registerCarouselVisibility"
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "attachments": {
            "type": "string"
        },
        "partid": {
            "type": "string"
        },
        "provider": {
            "type": "string"
        },
        "catalogspaceid": {
            "type": "string"
        },
        "hideelements": {
            "type": "string"
        },
        "locale": {
            "type": "string"
        },
        "featureGroupId": {
            "type": "string"
        },
        "disablecarousel": {
            "type": "boolean"
        }
    },
    "data": {
        "name": {
            "displayName": "{{i18n.name}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        },
        "manufacturer": {
            "displayName": "{{i18n.manufacturer}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        },
        "catalog": {
            "displayName": "{{i18n.catalog}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        },
        "partNo": {
            "displayName": "{{i18n.partNo}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false",
            "dbValue": "",
            "dispValue": ""
        },
        "propertiesLabel": {
            "displayName": "{{i18n.properties}}",
            "type": "STRING",
            "isRequired": "false",
            "isEditable": "false"
        },
        "viewList": {
            "displayName": "Viewer",
            "name": "viewList",
            "type": "STRING",
            "isRequired": false,
            "dataProvider": "viewListProvider"
        },
        "downloadButtonCommand": {
            "action": "downloadAction",
            "iconName": "cmdDownload24"
        },
        "previousPreviewButtonCommand": {
            "action": "previousPreviewAction",
            "iconName": "miscChevronLeft24"
        },
        "nextPreviewButtonCommand": {
            "action": "nextPreviewAction",
            "iconName": "miscChevronRight16"
        },
        "showDownloadPopup": false,
        "showWebglView": false,
        "checkForResetSelection": false,
        "command": "des_resetPartFamilyConfiguration",
        "webglViewerSrc": "",
        "pdfViewerSrc": "",
        "imageViewerSrc": "",
        "pageSize": 40,
        "_constants": {
            "PROPERTIES": "properties",
            "PART_CONFIGURATION": "configuration",
            "PREVIEW": "preview"
        },
        "defaultPreview": {
            "dbValue": ""
        },
        "isPropsUpdated": false,
        "refreshTableLov": false,
        "getFeatureGroupInput": {},
        "changeCount": 0,
        "displayView": {
            "type": "STRING",
            "dbValue": ""
        },
        "ViewerSrc": {
            "type": "STRING"
        },
        "allViewersInfo": [],
        "viewerInfo": {},
        "propOfPart": []
    },
    "grids": {
        "partSummaryTable": {
            "dataProvider": "partSummaryTableRowProvider",
            "columnProvider": "partSummaryTableColumnProvider",
            "addIconColumn": false,
            "gridOptions": {
                "enablePinning": false,
                "enableSorting": false,
                "enableCellHeaderSelection": false
            }
        }
    },
    "actions": {
        "registerCarouselVisibility": {
            "actionType": "JSFunctionAsync",
            "method": "registerCarouselVisibility",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "getPartDetails": {
            "actionType": "JSFunctionAsync",
            "method": "getPartDetails",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}",
                "selectedObjects": "{{parameters.eventData}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "listProductsForFeatureGroup": {
            "actionType": "JSFunction",
            "method": "updateVmoByName",
            "inputData": {
                "vmo": "{{data}}",
                "name": "listProductForFeatureGroup",
                "val": true
            },
            "outputData": {
                "refreshTableLov": "refreshTableLov"
            },
            "events": {
                "success": [
                    {
                        "name": "refreshSublocation"
                    }
                ]
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "loadSummary": {
            "actionType": "JSFunctionAsync",
            "method": "loadPartDetails",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}"
            },
            "outputData": {
                "part": "part",
                "output": "output",
                "partSummary": "propertiesOfPart",
                "propertiesOfPart": "propertiesOfPart",
                "inputsForFeatureGroup": "inputsForFeatureGroup",
                "webglViewerSrc": "webGlSrc",
                "pdfViewerSrc": "pdfjsSrc",
                "viewerInfo": "viewerInfo",
                "allViewersInfo": "allViewersInfo",
                "editConfig": "editConfig",
                "filterResults": "{{function:processResults}}",
                "propOfPart": "propOfPart"
            },
            "events": {
                "success": [
                    {
                        "name": "onLoadSummary.autoSelectFirst"
                    },
                    {
                        "name": "updateAllViewersSRC",
                        "eventData": {
                            "eventName": "updateAllViewersSRC",
                            "eventData": "{{allViewersInfo}}"
                        }
                    },
                    {
                        "name": "loadSummary.success_NOBODY_IS_USING_THIS_CAN_BE_REMOVED",
                        "condition": "data.refreshTableLov === false"
                    },
                    {
                        "name": "updatePartProperties",
                        "condition": "data.refreshTableLov === false"
                    }
                ]
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "loadColumnsBatchJob": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "loadSummary"
                },
                {
                    "action": "loadColumns"
                }
            ]
        },
        "loadColumns": {
            "actionType": "JSFunctionAsync",
            "method": "loadMatrixColumns",
            "inputData": {
                "vmo": "{{data}}",
                "dataProvider": "{{data.dataProviders.partSummaryTableRowProvider}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "getWebglSrc": {
            "actionType": "JSFunction",
            "method": "getWebglViewerSrcString",
            "inputData": {
                "vmo": "{{data}}",
                "viewerSrc": "{{parameters.eventData}}",
                "props": "{{props}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "doRegisterSelectedObject": {
            "actionType": "JSFunction",
            "method": "registerSelectedObject",
            "inputData": {
                "selectedObjects": "{{parameters.eventData}}",
                "vmo": "{{data}}"
            },
            "outputData": {
                "previousLOVvalue": "previousLOVvalue"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "performBatchActionOnLOVSelection": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "getFeatureGroupValuesInputForProduct"
                }
            ]
        },
        "getFeatureGroupValuesInputForProduct": {
            "actionType": "JSFunctionAsync",
            "method": "getFeatureGroupValuesInput",
            "inputData": {
                "inputFeatureData": "{{parameters.eventData}}",
                "vmo": "{{data}}"
            },
            "outputData": {
                "inputValuesOfFeatureGroup": "inputValuesOfFeatureGroup"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "resetPartConfigBatchActions": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "updateCancelEditActionFlag"
                },
                {
                    "action": "cancelEditAction"
                },
                {
                    "action": "reveal"
                },
                {
                    "action": "executePostResetConfig"
                }
            ]
        },
        "refreshFeatureGroup": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "updateLovChangeFlag",
                    "inputArgs": {
                        "eventData": "{{parameters.eventData}}"
                    }
                }
            ]
        },
        "updateCancelEditActionFlag": {
            "actionType": "JSFunctionAsync",
            "method": "updateCancelEditActionFlag",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "executePostResetConfig": {
            "actionType": "JSFunctionAsync",
            "method": "executePostResetConfig",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "updateProperties": {
            "actionType": "JSFunction",
            "method": "SetProperties",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}",
                "part": "{{data.part}}",
                "invokedFrom": "part-summary"
            },
            "outputData": {
                "isPropsUpdated": "partPropsUpdated"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "updateLovChangeFlag": {
            "actionType": "JSFunction",
            "method": "updateConfigLovChnagedFlag",
            "inputData": {
                "vmo": "{{data}}",
                "eventData": "{{parameters.eventData}}"
            },
            "outputData_old": {
                "refreshTableLov": "refreshTableLov",
                "getFeatureGroupInput": "getFeatureGroupInput"
            },
            "events1": {
                "success": [
                    {
                        "action": "reveal",
                        "condition": "data.refreshTableLov === true"
                    }
                ]
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "applyConfigBatchActions": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "cancelEditAction"
                },
                {
                    "action": "listProductsForFeatureGroup"
                }
            ]
        },
        "applyConfigSuccess": {
            "actionType": "JSFunction",
            "method": "onAfterApplyConfig",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "updatePartPropertiesConfig": {
            "actionType": "JSFunction",
            "method": "updatePartPropertiesConfig",
            "inputData": {
                "vmo": "{{data.propertiesOfPart}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "updatePropertiesOnSelection": {
            "actionType": "JSFunction",
            "method": "SetProperties",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}",
                "part": "{{parameters.eventData}}",
                "invokedFrom": "part-summary"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "setProductSelection": {
            "actionType": "JSFunction",
            "method": "setProductSelection",
            "inputData": {
                "autoSelectFirst": "true",
                "data": "{{data}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "performBatchActionOnCatalogPartSelection": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "publishToACCEventBus",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "setProductSelection"
                }
            ]
        }
    },
    "dataProviders": {
        "partSummaryTableRowProvider": {
            "dataProviderType": "Static",
            "response": "{{data.propOfPart}}",
            "selectionModelMode": "single",
            "totalFound": "{{data.propOfPart.length}}"
        },
        "viewListProvider": {
            "propDisplayValue": "{{data.partSummary.name}}",
            "dispValue": "{{data.partSummary.name}}",
            "propInternalValue": "{{data.partSummary.name}}"
        }
    },
    "columnProviders": {
        "partSummaryTableColumnProvider": {
            "frozenColumnIndex": -1,
            "loadColumnAction": "loadColumnsBatchJob",
            "columns": "{{data.columns}}"
        }
    },
    "onEvent": [
        {
            "eventId": "onLoadSummary.autoSelectFirst",
            "action": "setProductSelection"
        },
        {
            "eventId": "partSummaryTableRowProvider.selectionChangeEvent",
            "cacheEventData": false,
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "partSummaryTableRowProvider.selectionChangeEvent",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "lovChanged.refreshTable",
            "action": "reveal"
        },
        {
            "eventId": "desWebGlViewer",
            "action": "getWebglSrc",
            "inputArgs": {
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "resetPartConfig.initiated",
            "action": "resetPartConfigBatchActions"
        },
        {
            "eventId": "applyPartConfig.initiated",
            "action": "applyConfigBatchActions"
        },
        {
            "eventId": "updatePartProperties",
            "action": "updateProperties",
            "condition_commented": "conditions.isPropsUpdated"
        },
        {
            "eventId": "des-feature-group.selectionChange",
            "action": "refreshFeatureGroup",
            "cacheEventData": false,
            "inputArgs": {
                "eventData": "{{eventData}}"
            }
        },
        {
            "eventId": "des-feature-group.invalidSelection",
            "message": "desInvalidFeatureGroupSelection"
        },
        {
            "eventId": "refreshSublocation",
            "action": "reveal"
        },
        {
            "eventId": "partConfigCancel.initiated",
            "action": "cancelEditAction"
        },
        {
            "eventId": "applyPartConfig.error",
            "message": "desInvalidFeatureGroupSelectionWithName"
        },
        {
            "eventId": "getProperties.success",
            "cacheEventData": false,
            "action": "updatePropertiesOnSelection",
            "inputArgs": {
                "eventData": "{{eventData}}"
            }
        }
    ],
    "functions": {
        "processResults": {
            "functionName": "processResults",
            "parameters": [
                "{{data.dataProviders.partSummaryTableRowProvider.startIndex}}",
                "{{data.pageSize}}",
                "{{data}}"
            ],
            "deps": "js/DesCatalogPartConfigService"
        }
    },
    "conditions": {
        "isLOVChanged": {
            "expression": "data.previousLOVvalue !== data.inputValuesOfFeatureGroup.propDisplayValue"
        },
        "enableProperties": {
            "expression": "!( props.hideelements && props.hideelements.split(',').indexOf(data._constants.PROPERTIES) > -1)"
        },
        "enablePreview": {
            "expression": "!( props.hideelements && props.hideelements.split(',').indexOf(data._constants.PREVIEW) > -1)"
        },
        "enableConfiguration": {
            "expression": "!( props.hideelements && props.hideelements.split(',').indexOf(data._constants.PART_CONFIGURATION) > -1)"
        },
        "isPropsUpdated": {
            "expression": "( data.isPropsUpdated === false )"
        },
        "enableDefaultPreview": {
            "expression": "( data.defaultPreview.dbValue.length > 1  )"
        },
        "enableWebglPreview": {
            "expression": "( data.showWebglView === true && data.webglViewerSrc.length > 0 )"
        },
        "hidePreviewAndProperties": {
            "expression": "( props.hideelements === 'preview,properties' )"
        },
        "isPartAvailable": {
            "expression": "(data.partNo.value === '' ? false : true)"
        }
    },
    "i18n": {
        "partConfiguration": [
            "DesCatalogPartSummaryMessages"
        ],
        "name": [
            "DesCatalogPartSummaryMessages"
        ],
        "value": [
            "DesCatalogPartSummaryMessages"
        ],
        "preview": [
            "DesCatalogPartSummaryMessages"
        ],
        "manufacturer": [
            "DesCatalogPartSummaryMessages"
        ],
        "catalog": [
            "DesCatalogPartSummaryMessages"
        ],
        "partNo": [
            "DesCatalogPartSummaryMessages"
        ],
        "invalidLovSelection": [
            "DesCatalogPartSummaryMessages"
        ],
        "invalidFeatureGroupSelectionWithName": [
            "DesCatalogPartSummaryMessages"
        ],
        "properties": [
            "DesCatalogPartSummaryMessages"
        ]
    },
    "messages": {
        "desInvalidFeatureGroupSelection": {
            "messageType": "ERROR",
            "messageText": "{{i18n.invalidLovSelection}}"
        },
        "desInvalidFeatureGroupSelectionWithName": {
            "messageType": "ERROR",
            "messageText": "{{i18n.invalidFeatureGroupSelectionWithName}}",
            "messageTextParams": [
                "{{ctx.invalidFeatureGroupSelection.featureGroup.propInternalValue}}"
            ]
        }
    },
    "_viewModelId": "DesCatalogPartConfig",
    "_uniqueViewModelId": "DesCatalogPartConfig",
    "ctx": {
        "invalidFeatureGroupSelection": {
            "type": "object"
        }
    }
};

    /*
    <div style="width: 100%; height: 100%; display: flex; flex-direction: column;" class="afx-content-background">
    <aw-panel class="h-12" exist-when="!conditions.hidePreviewAndProperties">
        <aw-panel-body>
            <aw-flex-row height="6">
                <aw-splm-table gridid="partSummaryTable"></aw-splm-table>
            </aw-flex-row>
            <aw-break> </aw-break>
            <aw-flex-row height="6" width="12">
                <aw-flex-column class="des-part-preview-container" width="6" exist-when="conditions.enablePreview">
                    <aw-flex-row height="fill" exist-when="conditions.enableDefaultPreview">
                        <aw-panel-section caption="{{i18n.preview}}">
                            <des-catalog-carousel allViewersSRC={{data.viewerInfo.propInternalValue}}
                                accsessionid={{props.accsessionid}} provider={{props.provider}} catalogspaceid={{props.catalogspaceid}}
                                locale={{props.locale}} disable-carousel={{props.disablecarousel}}>
                            </des-catalog-carousel>
                        </aw-panel-section>
                    </aw-flex-row>
                </aw-flex-column>
                <aw-flex-column width="6">
                    <aw-flex-row height="fill" exist-when="conditions.enableDefaultPreview && (conditions.enableConfiguration || conditions.enableProperties)">
                        <aw-panel-section caption="{{i18n.properties}}">
                            <aw-label prop="data.name"></aw-label>
                            <aw-label prop="data.catalog"></aw-label>
                            <aw-label exist-when="conditions.isPartAvailable" prop="data.partNo"></aw-label>
                        </aw-panel-section>
                    </aw-flex-row>
                </aw-flex-column>
            </aw-flex-row>
        </aw-panel-body>
    </aw-panel>

    <aw-flex-row height="12" exist-when="conditions.hidePreviewAndProperties">
        <aw-splm-table gridid="partSummaryTable"></aw-splm-table>
    </aw-flex-row>
</div>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}} className="afx-content-background">
        <AwPanelExistWhen  revealAction={actions.reveal}  className="h-12" existWhen={AwParseService.instance( "!conditions.hidePreviewAndProperties" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            <AwPanelBody>
                <AwFlexRow height="6">
                    <AwSplmTable {...grids.partSummaryTable}>
                    </AwSplmTable>
                </AwFlexRow>
                <AwBreak>
                </AwBreak>
                <AwFlexRow height="6" width="12">
                    <AwFlexColumnExistWhen className="des-part-preview-container" width="6" existWhen={AwParseService.instance( "conditions.enablePreview" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                        <AwFlexRowExistWhen height="fill" existWhen={AwParseService.instance( "conditions.enableDefaultPreview" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                            <AwPanelSection caption={AwParseService.instance( "i18n.preview" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                                <DesCatalogCarousel allviewerssrc={AwParseService.instance( "data.viewerInfo.propInternalValue" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} accsessionid={AwParseService.instance( "props.accsessionid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} provider={AwParseService.instance( "props.provider" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} catalogspaceid={AwParseService.instance( "props.catalogspaceid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} locale={AwParseService.instance( "props.locale" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} disable-carousel={AwParseService.instance( "props.disablecarousel" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                                </DesCatalogCarousel>
                            </AwPanelSection>
                        </AwFlexRowExistWhen>
                    </AwFlexColumnExistWhen>
                    <AwFlexColumn width="6">
                        <AwFlexRowExistWhen height="fill" existWhen={AwParseService.instance( "conditions.enableDefaultPreview && (conditions.enableConfiguration || conditions.enableProperties)" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                            <AwPanelSection caption={AwParseService.instance( "i18n.properties" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                                <AwLabel {...getField("data.name", fields, $index, null, null )}>
                                </AwLabel>
                                <AwLabel {...getField("data.catalog", fields, $index, null, null )}>
                                </AwLabel>
                                <AwLabelExistWhen {...getField("data.partNo", fields, $index, null, null )} existWhen={AwParseService.instance( "conditions.isPartAvailable" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                                </AwLabelExistWhen>
                            </AwPanelSection>
                        </AwFlexRowExistWhen>
                    </AwFlexColumn>
                </AwFlexRow>
            </AwPanelBody>
        </AwPanelExistWhen>
        <AwFlexRowExistWhen height="12" existWhen={AwParseService.instance( "conditions.hidePreviewAndProperties" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            <AwSplmTable {...grids.partSummaryTable}>
            </AwSplmTable>
        </AwFlexRowExistWhen>
    </div>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;